/**
 * Triggers file download for the given file.
 *
 * @param fileName
 * @param data
 * @param options
 */
export function downloadFromBlob(
  fileName: string,
  data: BlobPart[],
  options: FilePropertyBag
): void {
  const file: File = new File(
    data,
    fileName,
    options
  );

  const blobUrl: string = URL.createObjectURL(file);
  const link: HTMLAnchorElement = document.createElement('a');

  link.href = blobUrl;
  link.download = fileName;
  link.target = '_blank';
  link.textContent = 'download';

  document.body.appendChild(link);

  setTimeout((): void => {
    link.click();
    setTimeout((): void => {
      URL.revokeObjectURL(blobUrl);
      document.body.removeChild(link);
    }, 500);
  }, 500);
}
